import { Board } from "./Board.js";
import { Timer } from "./Timer.js";
import { createElement } from "@/utils/create-elem.js";
import { eventEmitter } from "@/utils/event-emitter.js";

export function GameSection(parent) {
  const gameSection = createElement({
    tag: "section",
    classes: ["game-section"],
    parent: parent,
  });
  Timer(gameSection);
  Board(gameSection);
  eventEmitter.on("renderBoard", () => {
    if (document.querySelector("#board")) {
      document.querySelector("#board").remove();
    }
    Board(gameSection);
  });
}
